import {
  deriveWorkspaceIdFromSummary,
  deriveWorkspaceIdFromUser
} from '../../domain/session/sessionSummary';
import {
  readStoredUser,
  readStoredUserSummary
} from '../../infrastructure/session/browserSessionStore';

export const resolveStoredWorkspaceId = (): string | null => {
  const summaryWorkspaceId = deriveWorkspaceIdFromSummary(
    readStoredUserSummary()
  );
  if (summaryWorkspaceId) {
    return summaryWorkspaceId;
  }

  return deriveWorkspaceIdFromUser(readStoredUser());
};

export const resolveWorkspaceRedirectPath = (
  buildPath: (workspaceId: string) => string,
  fallbackPath = '/home'
): string => {
  const workspaceId = resolveStoredWorkspaceId();
  return workspaceId ? buildPath(workspaceId) : fallbackPath;
};
